<app-header *ngIf="showHeader"></app-header>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-footer></app-footer>